/** Usage-rights wording for the Audio Studio: TikTok trends are TikTok-only; generated sounds are originals. */
export const RIGHTS = {
  tiktok: {
    label: 'TikTok only',
    tooltip: 'Licensed for TikTok business use via TikTok’s Commercial Music Library. For ads on Instagram, YouTube or other platforms, make an original with “Remix”.',
  },
  original: {
    label: 'Original',
    tooltip: 'Composed for your brand — usable in ads on any platform.',
  },
} as const;

export type RightsKind = keyof typeof RIGHTS;

/** Said once above the team's sounds (Recent creations, Your Collections) instead of a chip on every row. */
export const ORIGINALS_NOTE = 'All your sounds are originals — usable in ads on any platform.';

export const TRENDS_RIGHTS_NOTE = 'TikTok’s Commercial Music Library — cleared for TikTok ads. Make an original to use them anywhere.';

/** One line in the Remix dialog on what Remix makes (and why it frees the song from "TikTok only"). */
export const REMIX_NOTE = 'Remix makes an original track in this song’s style — tempo, instruments, energy — usable in ads anywhere.';

/** Remix dialog: what the user may do with the remix (always visible). Legal edits this copy here. */
export const REMIX_RIGHTS = {
  title: 'Rights for this remix',
  items: [
    { label: 'The trending song', text: "licensed for TikTok business use only (TikTok Commercial Music Library). Your remix doesn't reuse it." },
    { label: 'Your remix', text: "a new, original composition in the song's style. No melody, lyrics or audio from the original are copied." },
    { label: 'Use it anywhere', text: 'your brand and your creators can use it in organic posts and paid ads on TikTok, Instagram, YouTube and other platforms.' },
  ],
} as const;

/** Remix dialog: how a remix is made and where it goes next (collapsible). */
export const REMIX_HOW_IT_WORKS = {
  title: 'How it works',
  steps: [
    'We listen to the trending song and map its style — tempo, key and which instruments play in each bar.',
    'We compose a new original from that map plus your instructions (about a minute).',
    'It appears in Recent creations — play it, rename it, share it.',
    "Add it to a beat or a creator's brief, or download it and send it to the creator. When their video runs as an ad, the music is already cleared.",
  ],
} as const;

export const MUSIC_RIGHTS_TERMS_LABEL = 'Music rights terms';
